// import { WarningFilled } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import { notification } from 'antd';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../../axios/axiosInstance';
import { UserEmail } from '../../model/classes/UserEmail';

interface PreferencesData {
  payload: UserEmail;
}

interface ErrorResponse {
  message: string;
  errors: string[];
}

function transformErrorData(data: any): ErrorResponse {
  const result: ErrorResponse = {
    message: data.message,
    errors: []
  };

  if (data.errors)
    for (const [, value] of Object.entries(data.errors)) {
      // @ts-ignore
      result.errors.push(value[0]);
    }

  return result;
}
export const useUpdateUserEmail = () =>
  useMutation(
    async ({ payload }: PreferencesData) => {
      const { data } = await axiosInstance.post(`/api/users/update-email`, {
        ...payload,
        _method: 'PATCH'
      });
      return data;
    },
    {
      onSuccess: () => {
        notification.success({
          message: 'Email Successfully Updated.',
          description:
            'A verification email has been sent to the new email address. Please confirm it in order to regain access to your Account.',
          duration: 5
        });
      },
      onError: (err: AxiosError) => {
        if (err.response) {
          const data = transformErrorData(err.response.data);
          notification.error({
            message: 'Update error ' + err.response?.status,
            description: data.errors.map((error: string) => {
              return (
                <p key={error} style={{ marginBottom: '5px' }}>
                  {error}
                </p>
              );
            })
          });
        }
      }
    }
  );
